import { HUB_BASE_URL } from "@constants/env";
import { HUB_ENDPOINTS } from "@memorang/constants/urls";

export const COPILOT_URL = `${HUB_BASE_URL}${HUB_ENDPOINTS.COPILOT_REDEEM}`;

export const AUTH_TOKEN_FETCH_ERROR_TITLE =
	"Redeem copilot auth token fetch failed";

export const APPS_REDEEM_AGENT_NAME = "apps-redeem-agent";
